import { extractConfigurationInfo } from "./extractConfigurationInfo";
import { isConfigurationInfoEmpty } from "./isConfigurationInfoEmpty";
export function hasConfigurationInfo(properties, attachments) {
    return !isConfigurationInfoEmpty(extractConfigurationInfo(properties, attachments));
}
//# sourceMappingURL=hasConfigurationInfo.js.map